import useSWR from "swr";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "../../../../../services/config";
import { MethodType } from "../../../../../services/type";
import { useTranslation } from "react-i18next";

export interface ReasonCode {
  id: number;
  corporateId: number;
  type: string;
  value: string;
  valueIt: string;
}

export interface FormattedOption {
  value: string;
  label: {
    en: string;
    it: string;
  };
}

export const useFetchReasonCodes = (corporateId: string, type: string) => {
  const swrFetcher = (url: string) => fetcher(url, MethodType.GET);
  const { t } = useTranslation();

  const { data, error, isLoading, mutate } = useSWR(() => {
    if (!corporateId) return null;
    return ServicesURL.getReasonCodes
      .replace("{corporateId}", corporateId)
      .replace("{type}", type);
  }, swrFetcher);

  // Format the reason codes for select options based on the actual response structure
  const formattedOptions =
    data?.reasonCodes?.map((item: ReasonCode) => ({
      value: item.value,
      label: {
        en: item.value,
        it: item.valueIt,
      },
    })) || [];

  return {
    reasonCodes: (data?.reasonCodes as ReasonCode[]) || [],
    formattedOptions,
    isLoading,
    isError: error,
    mutate,
  };
};
